import React from 'react';
import Alert from '@/Components/Alert';
import Button from '@/Components/Button';
import route from 'ziggy-js';

export default function AlertSignup() {
  return (
    <Alert
      title={<>This is a public snippet</>}
      className="collapsable"
      action={
        <div className="flex gap-2">
          <Button
            href={route('register')}
            styleType="primary"
            forceUrlDomain="app"
          >
            Sign Up
          </Button>
          <Button
            href={route('login')}
            styleType="primary"
            forceUrlDomain="app"
          >
            Sign In
          </Button>
        </div>
      }
    >
      <p>
        Sign Up or Sign In to create code like this or edit this code to your
        needs.
      </p>
    </Alert>
  );
}
